import { axiosGet } from 'shared/api/axios'
import { apiUrls } from 'consts'
import ActionButtons from 'shared/components/ActionButtons'

interface getRowsProps {
  id: string
}

const getRows = async (props: getRowsProps) => {
  const getParams = {id: props.id}

  const response = await axiosGet(apiUrls.filterSyncLog, getParams)

  const data = response.data

  data.forEach((row: any, index: number, dataArray: any) => {
    dataArray[index].logAction = dataArray[index].action

    if(dataArray[index].hasDetails){
      dataArray[index].action = (
        <ActionButtons
          buttons={[
            {
              type: 'r',
              url: '/filter-sync-log-details/' + row.id + '/' + props.id
            }
          ]}
        />
     )
    } else {
      dataArray[index].action = null
    }

  })

  return data
}

export default getRows
